// src/data/heavyDuty.js
import heavy1 from "../assets/heavyduty/IMG-20250827-WA0013.jpg";
import heavy2 from "../assets/heavyduty/IMG-20250827-WA0014.jpg";
import heavy3 from "../assets/heavyduty/IMG-20250827-WA0015.jpg";
import heavy4 from "../assets/heavyduty/IMG-20250827-WA0016.jpg";
import heavy5 from "../assets/heavyduty/IMG-20250827-WA0017.jpg";
import heavy6 from "../assets/heavyduty/IMG-20250827-WA0018.jpg";

const heavyDutyData = [
  {
    id: 1,
    name: "Heavy Duty Date With Time",
    category: "Heavy",
    image: heavy1,
    size: "40x40 mm",
    description: "Robust industrial stamp built for heavy daily use — metal frame and long-lasting ink pad.",
  },
  {
    id: 2,
    name: "Heavy Duty Date With Plate",
    category: "Heavy",
    image: heavy2,
    size: "40x40 mm",
    description: "Wide impression area for large text or logos; engineered for repeated, high-pressure stamping.",
  },
  {
    id: 3,
    name: "Heavy Duty Date With Plate",
    category: "Heavy",
    image: heavy3,
    size: "50x30 mm",
    description: "Steel-frame construction for maximum durability and consistent impressions in industrial environments.",
  },
  {
    id: 4,
    name: "Heavy Duty stamp",
    category: "Heavy",
    image: heavy4,
    size: "90x45 mm",
    description: "Integrated date + text layout. Ideal for warehouses and document control with rapid stamping cycles.",
  },
  {
    id: 5,
    name: "Heavy Duty Stamp",
    category: "Heavy",
    image: heavy5,
    size: "65x45 mm",
    description: "Multi-line heavy-duty stamp for addresses, serial numbers or multi-field text with clear, deep impressions.",
  },
  {
    id: 6,
    name: "Heavy Duty Extra-Large Stamp",
    category: "Heavy",
    image: heavy6,
    size: "105x65 mm",
    description: "Extra-large format for packaging and industrial labels — sturdy mechanism for long-term use.",
  },
];

export default heavyDutyData;





